// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message .el-textarea{width:496px;border-radius:0}.message .el-textarea__inner{height:126px!important}", ""]);
// Exports
module.exports = exports;
